/**
 * Fair Home V2 (redesign) — RedisignHomePage
 * BP: desktop ≥1024 · compact <1024
 */

import { FAIR_RD_DESKTOP_MIN_WIDTH } from '@/ui/tokens/redesign.data'

export const FAIR_HOME_V2_DESKTOP_MIN_WIDTH = FAIR_RD_DESKTOP_MIN_WIDTH

export function isFairHomeV2Compact(viewportWidth: number): boolean {
  return viewportWidth < FAIR_HOME_V2_DESKTOP_MIN_WIDTH
}

/** Scroll stack — Track H units H2–H9. Nodes: канон `15:*`. */
export const FAIR_HOME_V2_SECTIONS = [
  { id: 'hero', unit: 'H2', figmaDesktop: '15:9503', figmaCompact: '15:9523' },
  { id: 'capsules', unit: 'H4', figmaDesktop: '15:9530', figmaCompact: '15:9551' },
  { id: 'services', unit: 'H5b', figmaDesktop: '15:9694', figmaCompact: '15:9605' },
  { id: 'selected', unit: 'H6b', figmaDesktop: '15:9720', figmaCompact: '15:9569' },
  { id: 'ai', unit: 'H7', figmaDesktop: '15:9800', figmaCompact: '15:9803' },
  { id: 'popular', unit: 'H8', figmaDesktop: '15:9822', figmaCompact: '15:9586' },
  { id: 'footer', unit: 'H9', figmaDesktop: '15:9843', figmaCompact: '15:9844' },
] as const

export type FairHomeV2SectionId = (typeof FAIR_HOME_V2_SECTIONS)[number]['id']
